var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hooper',{ref:_vm.uid,attrs:{"settings":_vm.options},on:{"slide":_vm.onSlide}},[_vm._t("default",function(){return [_c('loading-circle')]}),(_vm.loaded > 0)?_c('hooper-navigation',{attrs:{"slot":"hooper-addons"},slot:"hooper-addons"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }